module.exports = __webpack_public_path__ + "img/carryall_thumb.a0773438.jpg";